module.exports = __webpack_public_path__ + "static/media/merge-red.904fde48.svg";